import type { RouteRecordRaw } from "vue-router";

export const generatedRoutes: RouteRecordRaw[] = [
  // {
  //   path: "/c4c3-api-bs-list",
  //   name: "doc-c4c3-api-bs-list",
  //   component: () => import("@/generated/pages/c4c3-api-bs-list.vue"),
  //   meta: { title: "流水查询-autoGen" },
  // },
  // {
  //   path: "/api-v1-sign-account-detail",
  //   name: "doc-api-v1-sign-account-detail",
  //   component: () => import("@/generated/pages/api-v1-sign-account-detail.vue"),
  //   meta: { title: "客户签约状态查询" },
  // },
  {
    path: "/api-v2-payment-salarypay",
    name: "doc-api-v2-payment-salarypay",
    component: () => import("@/generated/pages/api-v2-payment-salarypay.vue"),
    meta: { title: "代发(支付)-制单" },
  },
  {
    path: "/api-v2-payment-querysalarystatus",
    name: "doc-api-v2-payment-querysalarystatus",
    component: () =>
      import("@/generated/pages/api-v2-payment-querysalarystatus.vue"),
    meta: { title: "代发(支付)-支付状态查询" },
  },
  {
    path: "/api-v2-bs-list",
    name: "doc-api-v2-bs-list",
    component: () => import("@/generated/pages/api-v2-bs-list.vue"),
    meta: { title: "流水查询" },
  },
  {
    path: "/api-v2-balance-current",
    name: "doc-api-v2-balance-current",
    component: () => import("@/generated/pages/api-v2-balance-current.vue"),
    meta: { title: "实时余额查询" },
  },
  {
    path: "/api-v2-balance-history",
    name: "doc-api-v2-balance-history",
    component: () => import("@/generated/pages/api-v2-balance-history.vue"),
    meta: { title: "历史余额查询" },
  },
  {
    path: "/api-v2-sign-generatelink",
    name: "doc-api-v2-sign-generatelink",
    component: () => import("@/generated/pages/api-v2-sign-generatelink.vue"),
    meta: { title: "获取签约链接" },
  },
  {
    path: "/api-v2-sign-account-detail",
    name: "doc-api-v2-sign-account-detail",
    component: () => import("@/generated/pages/api-v2-sign-account-detail.vue"),
    meta: { title: "客户签约状态查询" },
  },
  {
    path: "/api-v2-bs-ebill-download",
    name: "doc-api-v2-bs-ebill-download",
    component: () => import("@/generated/pages/api-v2-bs-ebill-download.vue"),
    meta: { title: "回单下载" },
  },
    { path: '/api-v2-bank-searchbranch', name: 'doc-api-v2-bank-searchbranch', component: () => import('@/generated/pages/api-v2-bank-searchbranch.vue'), meta: { title: '支行信息查询' } }

];
